import { createAction } from 'redux-actions';

export const setSchoolAttendances = createAction('SET_SCHOOL_ATTENDANCES');
export const setSchoolXAttendances = createAction('SET_SCHOOL_X_ATTENDANCES');
export const updateSchoolAttendance = createAction('UPDATE_SCHOOL_ATTENDANCE');
export const updateSchoolXAttendance = createAction('UPDATE_SCHOOL_X_ATTENDANCE');
export const setAbsenceReasons = createAction('SET_ABSENCE_REASONS');
export const toggleAbsentModal = createAction('TOGGLE_ABSENT_MODAL');
export const setOpenCommentForm = createAction('SET_OPEN_COMMENT_FORM');
export const setAbsentSucceed = createAction('SET_ABSENT_SUCCEED');
export const toggleCancelAbsentSucceedModal = createAction('TOGGLE_CANCEL_ABSENT_SUCCEED_MODAL');

export const setCancelAbsentSubmitting = createAction('SET_CANCEL_ABSENT_SUBMITTING');
export const toggleTooltip = createAction('TOGGLE_TOOLTIP');
export const setSchoolExtraClasses = createAction('SET_SCHOOL_EXTRA_CLASSES');
export const setPreAbsences = createAction('SET_PRE_ABSENCES');
export const toggleSchoolExtraClassModal = createAction('TOGGLE_SCHOOL_EXTRA_CLASS_MODAL');
export const setAddSchoolExtraClassSucceed = createAction('SET_ADD_SCHOOL_EXTRA_CLASS_SUCCEED');
export const updateSchoolExtraClass = createAction('UPDATE_SCHOOL_EXTRA_CLASS');
export const setCancelSchoolExtraClassSubmitting = createAction('SET_CANCEL_SCHOOL_EXTRA_CLASS_SUBMITTING');
export const toggleCancelExtraClassSucceedModal = createAction('TOGGLE_CANCEL_EXTRA_CLASS_MODAL');
export const updatePreAbsence = createAction('UPDATE_PRE_ABSENCE');

export const SAGA_ABSENT = 'SAGA_ABSENT';
export const SAGA_SCHOOL_X_ABSENT = 'SAGA_SCHOOL_X_ABSENT';
export const SAGA_CANCEL_ABSENT = 'SAGA_CANCEL_ABSENT';
export const SAGA_SCHOOL_X_CANCEL_ABSENT = 'SAGA_SCHOOL_X_CANCEL_ABSENT';
export const SAGA_ADD_SCHOOL_EXTRA_CLASS = 'SAGA_ADD_SCHOOL_EXTRA_CLASS';
export const SAGA_CANCEL_EXTRA_CLASS = 'SAGA_CANCEL_EXTRA_CLASS';
